import React, {useEffect, useState} from 'react'
import {Container, SelectMultiple} from './styled'
import { userType } from 'components/page/main/monitoring/customTables/monitoring'
const UserType = props => {

    const optionsType = Object.entries(userType).map(([value, label]) => ({label, value:Number(value)}))
    const {t} = props
    const {filter, setFilter} = props.filter
    const [type_user, setTypeUser] = useState(filter.type_user ? [...filter.type_user] : [])
    useEffect(() => {
        setFilter({type_user})
    }, [type_user])

    return <Container>
        <h5>Tipo de perfil</h5>
        <SelectMultiple options={optionsType} isMulti={true}
                        value={type_user.map(type => optionsType.find(({ value }) => value === type))}
                        onChange={(e) => setTypeUser(e?.map(({ value }) => value) || [])}/>
    </Container>
}

export default UserType